import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FAILED, IDLE, LOADING, NEEDS_REFRESH, SUCCEEDED } from "./constants";
import {
  getAllParentAccounts,
  getParentAccountTypes,
  saveAllParentAccounts,
} from "../../utils/api/ParentAccountsApi";

import { RootState } from "../store/store";
import { getOktaUser } from "../../utils/LocalStorage";

export interface parentAccountsState {
  parentAccounts: any[];
  parentAccountTypes: string[];
  selectedUnit: any;
  selectedUnitStatus: string;
  bulkUploadStatus: string;
  saveAllStatus: string;
  fetchAllParentAccountsStatus: string;
  status: string;
  error: any;
  lastUpdated: string;
}

const initialState: parentAccountsState = {
  parentAccounts: [],
  parentAccountTypes: [],
  selectedUnit: null,
  selectedUnitStatus: IDLE,
  bulkUploadStatus: IDLE,
  saveAllStatus: IDLE,
  fetchAllParentAccountsStatus: IDLE,
  status: IDLE,
  error: null,
  lastUpdated: "",
};
export const fetchAllParentAccounts = createAsyncThunk(
  "/parent-accounts",
  async (param, thunkAPI) => {
    let parentAccountsFetch = await getAllParentAccounts();
    let parentAccountTypesFetch = await getParentAccountTypes();
    let parentAccountTypes: any = parentAccountTypesFetch.accountTypeList;
    let parentAccounts: any = parentAccountsFetch.parentAccountList;

    for (const element of parentAccounts) {
      element.openDate = gridDateFormatter(element.openDate);
      element.closeDate = gridDateFormatter(element.closeDate);
    }
    return { parentAccounts, parentAccountTypes };
  }
);

export const saveParentAccounts = createAsyncThunk(
  "/save-all",
  async (saveAll: any, thunkAPI) => {
    const userName = getOktaUser()[2];
    const body: any = { userName, saveAll };

    let response;

    const importArr: any = [];
    importArr.push(saveAll);
    response = await saveAllParentAccounts(body);
    return response;
  }
);
function gridDateFormatter(stringDate: string) {
  if (stringDate == null) {
    return "";
  }
  let date = new Date(stringDate);
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: "UTC",
  };
  // @ts-ignore
  return date.toLocaleDateString("en-CA", options);
}
export const parentAccountsSlice = createSlice({
  name: "ParentAccounts",
  initialState,
  reducers: {
    alertRefreshParentAccounts: (state) => {
      state.fetchAllParentAccountsStatus = NEEDS_REFRESH;
    },
    updateBankInformation: (state, action) => {
      state.parentAccounts = action.payload;
    },
    resetBulkUploadStatus: (state) => {
      state.bulkUploadStatus = IDLE;
    },
    resetSaveAllStatus: (state) => {
      state.saveAllStatus = IDLE;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchAllParentAccounts.pending, (state, action) => {
        state.fetchAllParentAccountsStatus = LOADING;
      })
      .addCase(fetchAllParentAccounts.fulfilled, (state, action) => {
        state.fetchAllParentAccountsStatus = SUCCEEDED;
        state.parentAccounts = action.payload.parentAccounts;
        state.parentAccountTypes = action.payload.parentAccountTypes;
      })
      .addCase(fetchAllParentAccounts.rejected, (state, action) => {
        state.fetchAllParentAccountsStatus = FAILED;
        state.error = action.error.message;
      })
      .addCase(saveParentAccounts.pending, (state, action) => {
        state.saveAllStatus = LOADING;
      })
      .addCase(saveParentAccounts.fulfilled, (state, action) => {
        state.saveAllStatus = SUCCEEDED;
      })
      .addCase(saveParentAccounts.rejected, (state, action) => {
        state.saveAllStatus = FAILED;
        state.error = action.error.message;
      });
  },
});

export default parentAccountsSlice.reducer;
export const { alertRefreshParentAccounts, resetSaveAllStatus } =
  parentAccountsSlice.actions;

export const parentAccountsSelector = (state: RootState) =>
  state.parentAccounts.parentAccounts;
